app.service("shopsDetails", function(loading ,console, modal, shopsList, shopsMap, cartBox, cartManager) {
	var $self;
	var viewType, responseHTML, responseData, productId, lastAjaxData;

	function view(type){
		if(!responseHTML){
			return;
		}
		var $li=$("<div>"+responseHTML+"</div>");
		viewType=type;
		if(viewType==='map' && $li.find('.js-shop').length){
			$self.removeClass('shops-list').addClass('shops-map');
			shopsMap.update(responseHTML);
		}else if(viewType==='list'){
			$self.removeClass('shops-map').addClass('shops-list');
			shopsList.update(responseHTML);
		}else{
			console.log('shopsDetails: błąd wyświetlania');
		}
	}
	function available(checked,view){
		var data=$.extend(true, responseData, { onlyAvailable:checked, showAllAvailableShops: false });
		load(data, view);
	}
 	function load(data,view){
 		viewType=view;
		lastAjaxData=data;
		//loading.start();
		$self.addClass('loading');
		var url=(data.product_id?'/refresh-shops-with-product.ltr':'/shops-refresh-element.ltr');
		$.ajax({
			url:url,
			data:data,
			success:function(html){
				loadSuccess(html,data);
			},
			error:function(){
				loadError();
			}
		});
	}
	function loadError(){
		$self.removeClass('loading');
		//loading.stop();
	}
	function loadSuccess(html,data){
		responseHTML=html;
		responseData=data;
		//loading.stop();
		$self.removeClass('loading');
		view(viewType);
	}

	function makeReservation(shopCode) {
		cartManager.addProduct({
			productId:productId,
			addedFrom:'SHOPS_WITH_PRODUCT',
			delivery:'SHOP',
			shopCode: shopCode
		});
	}
	function setEvents(){
		$self.on('click', '.js-reserve', function(e) {
			e.preventDefault();
			console.log('reserve');
			makeReservation($(this).data('shop'));
		});
		
		$self.on('click', '.js-go-to-navigation', function(e) {
			e.preventDefault();
			goToNavigation($(this).data('longitude'), $(this).data('latitude'), $(this).data('shop'));
		});
		$self.on('click', '.js-show-all-available-shops', function() {
			load(
				$.extend( true, lastAjaxData, { showAllAvailableShops: true } ),
				'list'
			);
		});
	}
	function redirectNavigation(longitude, latitude){
		var iOS = /ipad|iphone|ipod/i.test(navigator.userAgent.toLowerCase());
		var url = '';
		if(iOS) {
			url = 'http://maps.apple.com/?daddr=' + latitude + ',' + longitude;
		}else {
			url = 'geo:0,0?q=' + latitude + ',' + longitude + '&z=18';
		}
		window.location = url;
	}
	function goToNavigation(longitude, latitude, code) {
		UA.interaction('Nawiguj do sklepu', code);
		euro.shopEventLog({
			id: "nawiguj-do-sklepu",
			f04: viewType,
			f05: code
		});
		modal.generate({
			content:'Opuszczasz serwis i przechodzisz do aplikacji',
			buttons:[
				{
					text:'OK',
					cssClass:'btn-primary',
					click:function(){
						redirectNavigation(longitude, latitude);
					}
				},{
					text:'Anuluj',
					cssClass:'btn-third',
					click:function(){
						 modal.close();
					}
				}
			]
		});
	}
	function init(product){
		$self=$('#shops-details');
		productId=product;
		shopsList.init();
		shopsMap.init();
		setEvents();
	}

	return {
		init:init,
		available: available,
		view: view,
		load: load
	};
});
